<app-dialog-header [title]="title" (closeClicked)="onClose()">
</app-dialog-header>

<mat-dialog-content>
  <dl>
    <dt>Message</dt>
    <dd>{{ errorMessage }}</dd>

    @for (cause of causes; track cause) {
    <dt>Cause</dt>
    <dd>{{ cause }}</dd>
    }
  </dl>
</mat-dialog-content>

<mat-dialog-actions align="end">
  <button mat-flat-button color="primary" matDialogClose>Dismiss</button>
</mat-dialog-actions>
